import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FieldsetModule } from 'primeng/fieldset';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'fieldset',
    standalone: true,
    imports: [TranslateModule, FieldsetModule, ToggleSwitchModule, FormsModule],
    templateUrl: './fieldset.component.html',
    styleUrl: './fieldset.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldsetComponent {
    legend = input.required<string>();
    toggleable = input<boolean>(false); //shows input switch in legend
    collapsed = model<boolean>(false); //collapses the fieldset by default

    collapseValue = false;
    expandValue = true;

    collapsedChange = output<boolean>();
}
